// Mock data sourced from https://rolex9.net/promotion — all promotion bonuses
export const promotionGroups = [
  {
    title: "VIP Program",
    items: [
      {
        name: "Monthly Deposit Ranking",
        amount: "AUD 5,999",
        desc: "Compete in the exclusive monthly deposit ranking and win a share of the AUD 5,999 prize pool. The more you deposit throughout the month, the higher your ranking and the bigger your reward.",
      },
    ],
  },
  {
    title: "Random Second Withdraw Bonus",
    items: [
      {
        name: "Random Second Withdraw Bonus",
        amount: "Random",
        desc: "Every second withdrawal gets a random bonus — newly revised, as low as $10 to join. Surprise yourself with an extra payout on your next withdraw.",
      },
    ],
  },
  {
    title: "Information",
    items: [
      { name: "Birthday Bonus", amount: "AUD ?", desc: "Celebrate your birthday with a special bonus from Rolex9. Log in on your birthday to claim your gift — the amount is a surprise!" },
      { name: "Weekly Rebate", amount: "7%", desc: "Receive a 7% weekly rebate on your total losses. Automatically credited every week — no manual claim required." },
      { name: "Weekly Commission", amount: "7%", desc: "Earn 7% weekly commission on your downline's total activity. Build your referral network and collect commissions every week." },
      { name: "0.9% Total Bet Daily Rebate", amount: "0.9%", desc: "Earn 0.9% rebate on every total bet you place — credited daily regardless of wins or losses." },
    ],
  },
  {
    title: "Share Bonus",
    items: [
      { name: "WhatsApp Reward", amount: "AUD 39.99", desc: "Share Rolex9 on WhatsApp and earn AUD 39.99 as a reward. Easy social sharing with real cash back." },
      { name: "Facebook Share 10AUD", amount: "AUD 10", desc: "Share Rolex9 on Facebook to earn AUD 10 instantly. Post to your timeline or group and claim your bonus." },
      { name: "Facebook Share 30AUD", amount: "AUD 30", desc: "Higher-tier Facebook share bonus — earn AUD 30 by sharing Rolex9 across your Facebook network." },
      { name: "Facebook Share 50AUD", amount: "AUD 50", desc: "Maximum Facebook share bonus — earn AUD 50 for premium social sharing activity on Facebook." },
      { name: "Telegram Share 30AUD", amount: "AUD 30", desc: "Share Rolex9 on Telegram channels or groups and earn AUD 30. Perfect for Telegram communities." },
      { name: "Trusted Pokies Australia Share 35AUD", amount: "AUD 35", desc: "Partnered with Trusted Pokies Australia — share and earn AUD 35. Exclusive partner promotion for Australian players." },
      { name: "Free Share Bonus", amount: "AUD 3", desc: "Every 1 share earns AUD 3. Simply share your unique referral link and collect bonuses for every successful sign-up." },
    ],
  },
  {
    title: "Deposit Progressive",
    items: [
      { name: "Deposit Progressive $9 – $19", amount: "AUD ?", desc: "Progressive deposit bonus tier starting from $9 deposits up to $19. Higher deposits unlock bigger mystery bonuses." },
      { name: "Deposit Progressive $11 – $29", amount: "AUD ?", desc: "Mid-tier progressive bonus for deposits between $11 and $29. Mystery bonus amount revealed upon deposit." },
      { name: "Deposit Progressive $21 – $39", amount: "AUD ?", desc: "Higher progressive tier for deposits from $21 to $39. Larger deposits mean larger progressive rewards." },
      { name: "Deposit Progressive $31 – $59", amount: "AUD ?", desc: "Premium progressive bonus for deposits between $31 and $59. Unlock mystery bonuses at this deposit range." },
      { name: "Deposit Progressive $61 – $99", amount: "AUD ?", desc: "Top-tier progressive deposit bonus for deposits from $61 to $99. The highest progressive tier with maximum mystery rewards." },
    ],
  },
  {
    title: "Free Bonus",
    items: [
      { name: "Apps Daily Free", amount: "AUD 20", desc: "Download the Rolex9 app and claim AUD 20 daily free bonus. Available every single day exclusively for app users." },
      { name: "Free Chips", amount: "AUD 10", desc: "Claim AUD 10 in free chips to play any game on the platform. No deposit required — just log in and play." },
      { name: "Free 365 Days Bonus", amount: "up to 99AUD", desc: "A year-long bonus program offering daily free bonuses up to AUD 99. Log in every day for 365 days and collect escalating rewards." },
    ],
  },
  {
    title: "Special Bonus",
    items: [
      { name: "Check In Bonus", amount: "AUD ?", desc: "Daily check-in bonus — simply log in every day to claim a mystery bonus amount. Consistency pays off at Rolex9." },
      { name: "Lucky Wheel Bonus", amount: "AUD ?", desc: "Spin the Lucky Wheel for a chance to win random bonus prizes. Every spin is a new opportunity for free credits." },
      { name: "VIP Upgrade Bonus", amount: "AUD ?", desc: "Upgrade your VIP status and receive a mystery bonus reward. Higher VIP levels unlock bigger upgrade bonuses." },
      { name: "Golden Egg Bonus", amount: "AUD ?", desc: "Crack the Golden Egg to reveal a surprise bonus amount. A fun and exciting way to earn extra rewards on the platform." },
      { name: "VIP Loyalty Bonus", amount: "AUD ?", desc: "Loyal VIP members receive exclusive mystery loyalty bonuses as a reward for continued play and deposits." },
    ],
  },
  {
    title: "Second Deposit Bonus",
    items: [
      {
        name: "Second Deposit Bonus",
        amount: "Random",
        desc: "Make your second deposit and receive a random surprise bonus. Every second deposit brings a new unexpected reward.",
      },
    ],
  },
  {
    title: "Deposit Bonus",
    items: [
      { name: "Slot Daily Bonus", amount: "20%", desc: "Get a 20% bonus on your daily slot deposits. Play your favourite slot games with extra credits every day." },
      { name: "Slot Unlimited Bonus", amount: "10%", desc: "Unlimited 10% bonus on all slot deposits — no cap, no limit. Every slot deposit gets a 10% top-up." },
      { name: "Weekend Deposit", amount: "30%", desc: "Weekend special — earn a 30% bonus on all deposits made during the weekend. Friday through Sunday, every deposit gets boosted." },
      { name: "Every Deposit Random Bonus", amount: "AUD ?", desc: "Every single deposit triggers a random surprise bonus. No matter the amount or the day, there's always a bonus waiting." },
    ],
  },
  {
    title: "Daily & Weekly Deposit Bonus",
    items: [
      { name: "Daily Deposit 5 Time", amount: "AUD 9.99", desc: "Make 5 deposits in a single day and earn AUD 9.99 bonus. Perfect for active daily players who love to play consistently." },
      { name: "Daily Deposit 10 Time", amount: "AUD 19.99", desc: "Double your daily activity — make 10 deposits in one day and claim AUD 19.99 bonus reward." },
      { name: "Daily Deposit 30 Time", amount: "AUD 59.99", desc: "For high-volume daily players — 30 deposits in a single day unlocks a massive AUD 59.99 bonus." },
      { name: "Weekly Deposit 50 Time", amount: "AUD 79.99", desc: "Weekly achievement bonus — make 50 deposits across the week and earn AUD 79.99 as a loyalty reward." },
      { name: "Weekly Deposit 100 Time", amount: "AUD 169.99", desc: "The ultimate weekly deposit bonus — 100 deposits in a week unlocks an incredible AUD 169.99 reward for our most dedicated players." },
    ],
  },
];